export default __webpack_public_path__ + "static/media/caja-los-andes-color.55c4a9e4.svg";